export const sortFieldMap: Record<string, string> = {
  doctor_index: 'title',
  phone_index: 'title',
  event_index: 'startDate',
  internal_department_index: 'title',
  content_page_index: 'title',
};

export function getLobbyHeaderKeyByIndex(index: string): string {
  const mapping: Record<string, string> = {
    doctor_index: 'LOBBY.DOCTORS_RESULT_TITLE',
    phone_index: 'LOBBY.PHONE_RESULT_TITLE',
    event_index: 'LOBBY.EVENT_RESULT_TITLE',
    internal_department_index: 'LOBBY.CLINICS_RESULT_TITLE',
  };

  return mapping[index.toLowerCase()];
}

export const displayNameMap: Record<string, (item: any) => string> = {
  TypeId: item => item.typeText,
  Hospital: item => item.hospitalName,
  SubjectId: item => {
    if (Array.isArray(item.subjectText)) {
      return item.subjectText.join(', ');
    }
    return item.subjectText || '';
  },
  SubSubjectId: item => {
    if (Array.isArray(item.subSubjectText)) {
      return item.subSubjectText.join(', ');
    }
    return item.subSubjectText || '';
  },
  EventId: item => item.eventText,
  AudienceId: item => item.audienceText,
  InterestId: item => item.interestText,
  Departments: item => item.departments,
  PhoneFilter1: item => item.phoneFilter1,
  PhoneFilter2: item => item.phoneFilter2,
  PhoneFilter3: item => item.phoneFilter3
};